import secureApi from '../../utils/secureApi';
import { NewsArticleListResponse } from './types';

export async function listNewsArticles(search = '', page = 1) {
  const response = await secureApi.get<any>(
    `/api/v1/blogs/admin/news/list?search=${encodeURIComponent(search)}&page=${page}`
  );
  
  // secureApi returns response.data automatically
  // Handle API response structure: may be wrapped in { statusCode, data: {...} } or direct
  if (response && (response.paginatedResults || response.totalCount !== undefined)) {
    return response as NewsArticleListResponse; // Already the expected structure
  } else if (response && (response as any).data && ((response as any).data.paginatedResults || (response as any).data.totalCount !== undefined)) {
    return (response as any).data as NewsArticleListResponse; // Wrapped in data field
  }
  return response as NewsArticleListResponse; // Fallback
}
